/** The entry point. Mounts React and, in a development build only, the debug
 *  surface the screenshot harness drives (I15). */

import { createRoot } from "react-dom/client";
import "./styles/global.css";
import { App } from "./App.js";
import { registerOffline } from "./offline.js";

const host = document.getElementById("root");
if (host === null) throw new Error("index.html has no #root");

// Deliberately not wrapped in StrictMode. Its development-only double-invoke of
// effects would mount and dispose a Pixi Application twice per canvas, and the
// second mount races the first one's teardown over the same WebGL context - a
// failure that exists only in development and would waste a day to diagnose.
createRoot(host).render(<App />);

if (import.meta.env.DEV) {
  void import("./debug.js").then((m) => { m.installDebug(); });
}

// Offline. A no-op wherever the API is absent, which today is everywhere the
// game is served from: a service worker needs a secure context and this deploy
// is plain http. It costs one branch and starts working the day that changes.
registerOffline();
